import React, {useRef, useEffect, useContext } from 'react'; 
import cl from './TotalPrice.module.css' 
import { AppContext } from '../../../../providers/appProvider';

  
const TotalPrice = ({sum}) => {  
 
    // const scrollRef = useHorizontalScroll(80);   // gamoiyene --> ref={scrollRef}

    const { appState, app } = useContext(AppContext);

    return (
        <div className={ cl.totalBox }  > 
            {app.hasPermission("CLIENT_DEBT_SHOW") && 
                <div className={cl.financeBox } >
                    <div className={cl.financeDesc }>  კლიენტების დავალიანება </div>
                    <div style={{color:"#d80228", background: 'rgb(255 223 216)'}}  className={cl.financeValue}> { sum.ClientDebt} $</div> 
                </div>
            }
 
            {app.hasPermission("COMPANY_DEBT_SHOW") &&
            <div className={cl.financeBox }  >
                <div className={cl.financeDesc }>  კომპანიის დავალიანება </div>
                <div style={{color:"#d80228", background: 'rgb(255 223 216)'}} className={cl.financeValue}> { sum.CompanyDebt} $</div> 
            </div>
            }
  
           {app.hasPermission("COMPANY_DEBT_SHOW") &&
                <div className={cl.financeBox }  >
                    <div className={cl.financeDesc }>  კომპანიის მოგება </div>
                    <div style={{color:"#009688", background: '#d3e9e6'}} className={cl.financeValue}>  { sum.ClientTotalPrice - sum.CompanyTotalPrice }$</div> 
                </div> 
            }
             
 
        </div>
    );
};

export default TotalPrice;